import { Component, OnInit } from "@angular/core";
import { CoreConfigService } from "../../../../@core/services/config.service";
import languageLevels from "../../../auth/models/language-levels";
import wolrdLanguages from "../../../auth/models/languages";
import { UtilsService } from "../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../auth/service";
import { Router } from "@angular/router";
import { TutorialService } from "../../../auth/service/tutorial.service";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-onboarding-languages",
  templateUrl: "./onboarding-languages.component.html",
  styleUrls: ["./onboarding-languages.component.scss"],
})
export class OnboardingLanguagesComponent implements OnInit {
  //  Public
  public coreConfig: any;

  public currentUser: ICurrentUser;

  public items_languages: any = [];

  public language_levels: string[] = languageLevels;

  public languages_list: string[] = wolrdLanguages;

  public languages_levels_description: string = "";

  /**
     * Constructor
     *
     * @param {CoreConfigService} _coreConfigService
     *

     * @param _utilService
     * @param _userService
     * @param _authenticationService
     * @param _router
     */
  constructor(
    private _coreConfigService: CoreConfigService,
    private _utilService: UtilsService,
    private _userService: UserService,
    private _authenticationService: AuthenticationService,
    private _router: Router,
    public _tutorialService: TutorialService,
  ) {
    this._utilService.disableAutoHideLoading();
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  async ngOnInit() {
    this.language_levels.map(async (level: string) => {
      const title: string = await this._utilService.translate("LANGUAGE_LEVELS." + level + ".LABEL").then((str) => `${level} - ${str}`);
      const description: string = await this._utilService.translate("LANGUAGE_LEVELS." + level + ".DESCRIPTION");
      this.languages_levels_description += `${title}:${description}\n`;
    });

    this.currentUser = this._authenticationService.getCurrentUser();
    if (this.currentUser && this.currentUser.send_onboarding === 1) {
      await this._router.navigateByUrl("/dashboard/main");
      this._utilService.hideLoading();
      return false;
    }
    await this._userService
      .get(this.currentUser.hash)
      .then((result: any) => result.languages.map((lang: any) => this.items_languages.push(lang)))
      .then(() => this.addItem());

    this._utilService.hideLoading();
  }

  /**
   * Add Item
   */
  addItem() {
    this.items_languages.push({
      name: "",
      speak: "",
      write: "",
    });
  }

  /**
   * DeleteItem
   *
   * @param index
   */
  deleteItem(index: number) {
    delete this.items_languages[index];
    this.items_languages = this.items_languages.filter((i) => i);
    if (this.items_languages.length == 0) {
      this.addItem();
    }
  }

  async save() {
    let dataLanguages = this.items_languages.filter((i) => i.name?.length > 0 && i.write?.length > 0 && i.speak?.length > 0);

    let hasError: boolean = false;

    this.items_languages.map((lang: any) => {
      if (
        (lang.name !== "" && lang.speak === "" && lang.write === "") ||
        (lang.name !== "" && lang.speak !== "" && lang.write === "") ||
        (lang.name !== "" && lang.speak === "" && lang.write !== "") ||
        (lang.name === "" && lang.speak !== "" && lang.write === "") ||
        (lang.name === "" && lang.speak !== "" && lang.write !== "") ||
        (lang.name === "" && lang.speak === "" && lang.write !== "")
      ) {
        hasError = true;
      }
    });

    if (hasError) {
      await this._utilService.showSWALError({ text: "ERROR_LANGUAGES_FIELDS_EMPTY" });
      return false;
    }
    //check duplicate languages
    const checkedArray = this.items_languages.reduce((unique, o) => {
      if (!unique.some((obj) => obj.name === o.name)) {
        unique.push(o);
      }

      return unique;
    }, []);
    if (this.items_languages?.length !== checkedArray.length) {
      await this._utilService.showSWALError({ text: "ERROR_DUPLICATE_LANGUAGES" });
      return false;
    }
    //END check duplicate languages

    this._utilService.showLoading();

    return this._userService
      .update(this.currentUser.hash, { languages: dataLanguages })
      .then(async () => {
        await this._userService.getMe().then(() => {
          this._router.navigateByUrl("/onboarding/iban");
        });
      })
      .catch((err: any) => {
        console.error("err", err);
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_USER_DATA_INSERT" });
      });
  }

  showVideo() {
    this._tutorialService.video_to_play = "Onboarding";
    this._tutorialService.force_open_modal = true;
  }
}
